import { render, staticRenderFns } from "./PracasVtal.vue?vue&type=template&id=20d55e01&scoped=true&lang=pug&"
import script from "./PracasVtal.vue?vue&type=script&lang=js&"
export * from "./PracasVtal.vue?vue&type=script&lang=js&"
import style0 from "./PracasVtal.vue?vue&type=style&index=0&id=20d55e01&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d55e01",
  null
  
)

export default component.exports